import React from 'react'
import {
  ClickAwayListener,
  Grow,
  IconButton,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@material-ui/core'
import { useCookies } from 'react-cookie'

import AccountCircleTwoToneIcon from '@material-ui/icons/AccountCircleTwoTone'
import { useHistory } from 'react-router-dom'
import { useSession } from '../../contexts/SessionContext'

const useStyles = makeStyles(theme => ({
  loginButton: {
    background:
      'linear-gradient(20deg, rgba(232,102,59,1) 0%, rgba(255,141,112,1) 78%, rgba(240,209,200,1) 100%)',
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(0.5),
    },
  },
  popper: {
    paddingTop: theme.spacing(1.6),
  },
}))

const AccountMenu = () => {
  const classes = useStyles()
  const history = useHistory()
  const { setSessionData } = useSession()
  const [, , removeCookie] = useCookies(['statusCookie'])

  const [openMenu, setOpenMenu] = React.useState(false)
  const anchorRef = React.useRef(null)

  const handleMenuToggle = () => {
    setOpenMenu(prevOpen => !prevOpen)
  }

  const handleMenuClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpenMenu(false)
  }

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpenMenu(false)
    }
  }

  const prevOpen = React.useRef(openMenu)
  React.useEffect(() => {
    if (prevOpen.current === true && openMenu === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = openMenu
  }, [openMenu])

  const handleLogoutClick = async () => {
    setSessionData({})
    removeCookie('statusCookie')
    history.push('/')
  }

  return (
    <>
      <IconButton
        onClick={handleMenuToggle}
        ref={anchorRef}
        aria-controls={openMenu ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
      >
        <AccountCircleTwoToneIcon color="primary" />
      </IconButton>
      <Popper
        open={openMenu}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
          },
        }}
        className={classes.popper}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleMenuClose}>
                <MenuList
                  autoFocusItem={openMenu}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  {/* <MenuItem onClick={handleAccountClick}>Perfil</MenuItem> */}
                  <MenuItem onClick={handleLogoutClick}>Cerrar sesión</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}

export default AccountMenu
